<template>
  <div>
    <div class="Actions__Nav">
      <ul>
        <li v-for="action in actions" :key="action.actionId">
          <button
            @click="actionsOnTank"
            :style="{ color: action.color }"
            :data-action-id="action.actionId"
            :disabled="action.disabled"
          >
            <img :src="`../../assets/IkoneVinogradi/${action.iconName}.png`" alt="icon" />
            <span>{{action.text}}</span>
          </button>
        </li>
      </ul>

      <div class="Actions__Nav__Select">
        <v-select
          v-model="action_select"
          placeholder="Izaberi akciju"
          class="form-control-select"
          :items="actions"
          @input="actionsOnTank"
        ></v-select>
      </div>
      <!-- /.Actions__Nav__Select -->
    </div>
    <!-- /.Actions__Nav -->

    <div id="Dialog__Overlay" class="Dialog__Overlay v-overlay" style="z-index: 201;"></div>
    <div
      id="Dialog__Content"
      tabindex="-1"
      data-v-fae5bece
      class="Dialog__Content v-dialog__content"
    >
      <div id="Dialog" class="Dialog v-dialog v-dialog--active " v-bind:class="[(this.action !== '7' && this.action !== '8') ? ((this.action === '9') ? 'sadnja_modal' : makaClass) : 'siri_modal']">
        <div data-v-fae5bece class="v-card">
          <div data-v-fae5bece class="v-card__title headline lighten-2 v-card__title--primary" style="font-size: 24px!important;">
            <!-- Modal Titles  -->

            <div id="naslov"
              v-if="this.action === '1'"
            >Rezidba - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-if="this.action === '2'"
            >Đubrenje - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-if="this.action === '3'"
            >Mašinska obrada - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '4'"
            >
            Ručna obrada - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '5'"
            >Zaštita - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '6'"
            >Berba - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '7'"
            >Stanje - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '8'"
            >Parametri - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '9'"
            >Sadnja - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '10'"
            >Krčenje - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '11'"
            >Naslon - {{ this.naziv_vinograda }}</div>
            <div id="naslov"
              v-else-if="this.action === '12'"
            >{{ this.naziv_vinograda === "" ? this.strProdajaGrozdja : this.strProdajaGrozdja + ' - ' + this.naziv_vinograda }}</div>

            <button id="closeModalMagacinBtn" @click="actionsOnTank" class="v-btn v-btn--flat white">
              <v-icon>close</v-icon>
            </button>
          </div>

          <div data-v-fae5bece class="spacer"></div>
          <div v-if="this.action === '1'">
            <VineyardPruning @mounted="customMounted" />
          </div>
          <div v-if="this.action === '2'">
            <VineyardFertilization @mounted="customMounted" />
          </div>
          <div v-if="this.action === '3'">
            <VineyardMachining @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '4'">
            <VineyardHanding @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '5'">
            <VineyardSpraying @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '6'">
            <VineYardHarvest @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '7'">
            <VineyardCondition @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '8'">
            <VineyardParameter @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '9'">
            <VineYardRowComponent @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '10'">
            <VineyardDestroying @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '11'">
            <VineyardTrellis @mounted="customMounted" />
          </div>
          <div v-else-if="this.action === '12'">
            <VineyardSelling @mounted="customMounted" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { serverBus } from "../../main";

import VineyardPruning from "./../VineyardPruning";
import VineyardFertilization from "./../VineyardFertilization";
import VineyardMachining from "./../VineyardMachining";
import VineyardHanding from "./../VineyardHanding";
import VineYardRowComponent from "./../VineYardRow.vue";
import VineyardSpraying from "./../VineYardSpraying.vue";
import VineyardDestroying from "./../VineyardDestroying";
import VineyardCondition from "./../VineyardCondition";
import VineyardParameter from "./../VineyardParameter";
import VineyardTrellis from "./../VineyardTrellis";
import VineYardHarvest from "./../VineYardHarvest";
import VineyardSelling from "./../VineyardSelling";
import { daLiJeVinarija } from "../../helpers/Functions";

const MountedMixin = {
  mounted() {
    this.$emit("mounted");
  }
};

export default {
  name: "ActionsNavMagacin",
  dialog: false,
  data() {
    return {
      makaClass: "siri_vinogradi",
      action_select: 0,
      action: 0,
      vinogradId: 0,
      naziv_vinograda: "",
      id_vinograda: 0,
      izabrani_red: null,
      naziv_vinograda: "",
      actions: [
      ],
      vinarija: true,
      strProdajaGrozdja: "",
    };
  },
  components: {
    VineyardPruning: resolve => {
      setTimeout(() => {
        const component = VineyardPruning;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardFertilization: resolve => {
      setTimeout(() => {
        const component = VineyardFertilization;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardMachining: resolve => {
      setTimeout(() => {
        const component = VineyardMachining;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineYardHarvest: resolve => {
      setTimeout(() => {
        const component = VineYardHarvest;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardHanding: resolve => {
      setTimeout(() => {
        const component = VineyardHanding;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardSpraying: resolve => {
      setTimeout(() => {
        const component = VineyardSpraying;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineYardRowComponent: resolve => {
      setTimeout(() => {
        const component = VineYardRowComponent;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardDestroying: resolve => {
      setTimeout(() => {
        const component = VineyardDestroying;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardCondition: resolve => {
      setTimeout(() => {
        const component = VineyardCondition;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardParameter: resolve => {
      setTimeout(() => {
        const component = VineyardParameter;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardTrellis: resolve => {
      setTimeout(() => {
        const component = VineyardTrellis;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    VineyardSelling: resolve => {
      setTimeout(() => {
        const component = VineyardSelling;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    }
  },
  methods: {
    actionsOnTank(e) {
      const Dialog__Content = document.getElementById("Dialog__Content"),
        Dialog__Overlay = document.getElementById("Dialog__Overlay"),
        Tank = document.querySelectorAll(".VineyardDetails");
      
      let vueInstance = this;
      let isOpen = false;
      let isTankSelected = false;
      let vinogradId = 0;

      if (e.target !== undefined) {
        this.action = e.target.dataset.actionId;
      }

      function checkIsTankSelected() {
        if(vueInstance.izabrani_red !== undefined && vueInstance.izabrani_red !== null){
          vinogradId = vueInstance.izabrani_red.vineyardId;

              vueInstance.vinogradId = vueInstance.izabrani_red.vineyardId;
              vueInstance.naziv_vinograda = vueInstance.izabrani_red.vineyardName;

              isTankSelected = true;
        }
        else
          for (let i = 0; i < Tank.length; i++) {
            if (Tank[i].classList.contains("active")) {
            vinogradId = Tank[i].dataset.vineyardId;

              vueInstance.vinogradId = Tank[i].dataset.vineyardId;
              vueInstance.naziv_vinograda = Tank[i].dataset.vineyardName;

              isTankSelected = true;
              }

          }
      }

      function modalOpen() {
        if (!isOpen) {
          if (e.target !== undefined) {
            vueInstance.$data.actionId = e.target.dataset.actionId;
          }

          Dialog__Content.style.display = "flex";
          Dialog__Content.classList += " v-dialog__content--active";
          Dialog__Overlay.style.display = "block";
          Dialog__Overlay.classList += " v-overlay--active";

          isOpen = true;
        }
      }

      function modalClose() {
        Dialog__Content.style.display = "none";
        Dialog__Content.classList.remove("v-dialog__content--active");
        Dialog__Overlay.style.display = "none";
        Dialog__Overlay.classList.remove("v-overlay--active");

        isOpen = false;
        isTankSelected = false;

        for (let i = 0; i < Tank.length; i++) {
          Tank[i].classList.remove("active");
        }

        if(vueInstance.izabrani_red === null)
          serverBus.$emit("ucitaj_podatke_vinogradi", true);
        else
          serverBus.$emit("ucitaj_podatke_vinogradi", vueInstance.izabrani_red.edit);
            
      }

      console.log(e);

      if (e.target !== undefined) {
        if (e.target.nodeName !== "UL" && e.target.nodeName !== "DIV") {
          checkIsTankSelected();

          /**
           * SingleTank and EmptyTank
           */
          if(Tank.length > 0)
            if (Tank[0].classList[1] === "TankSingle") {
              vinogradId = Tank[0].dataset.vineyardId;

              vueInstance.vinogradId = Tank[0].dataset.vineyardId;
              vueInstance.naziv_vinograda = Tank[0].dataset.vineyardName;

              isTankSelected = true;
            }

          this.naziv_vinograda = vueInstance.naziv_vinograda;
          this.id_vinograda = vueInstance.vinogradId;
        }

        /**
         * Close Modal
         */
        if (e.target.id === "closeModalMagacinBtn") {
          modalClose();

          
          this.izabrani_red = null;
          this.naziv_vinograda = "";
          
          this.action_select = "undefined";
        } else {
          /**
           * Open Modal
           */

          if (isTankSelected || e.srcElement.innerText === "PRODAJA GROŽĐA" || e.srcElement.innerText === "PRODAJA PLODA") {
            modalOpen();
          } else {
            this.action = 0;
            alert("Niste izabrali vinograd.");
          }
        }
      } else {
        checkIsTankSelected();

        if(Tank.length > 0)
          if (Tank[0].classList[1] === "TankSingle") {
            vinogradId = Tank[0].dataset.vineyardId;

            vueInstance.vinogradId = Tank[0].dataset.vineyardId;
            vueInstance.naziv_vinograda = Tank[0].dataset.vineyardName;

            isTankSelected = true;
          }

        // // console.log(Tank[0].dataset);

        this.naziv_vinograda = vueInstance.naziv_vinograda;
        this.id_vinograda = vueInstance.vinogradId;

        if (e === "PRUNING" || e === "Rezidba") {
          if (!this.disable) {
            vueInstance.action = "1";
            vueInstance.$data.actionId = 1;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        }
        if (e === "FERTILIZATION" || e === "Đubrenje") {
          if (!this.disable) {
            vueInstance.action = "2";
            vueInstance.$data.actionId = 2;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        }
        if (e === "MACHIN" || e === "Mašinska obrada") {
          if (!this.disable) {
            vueInstance.action = "3";
            vueInstance.$data.actionId = 3;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "HAND" || e === "Ručna obrada") {
          if (!this.disable) {
            vueInstance.action = "4";
            vueInstance.$data.actionId = 4;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "FITO" || e === "Zaštita") {
          if (!this.disable) {
            vueInstance.action = "5";
            vueInstance.$data.actionId = 5;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "HARVEST" || e === "Berba") {
          if (!this.disable) {
            vueInstance.action = "6";
            vueInstance.$data.actionId = 6;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "STATE" || e === "Stanje") {
          if (!this.disable) {
            vueInstance.action = "7";
            vueInstance.$data.actionId = 7;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "PARAMETERS" || e === "Parametri") {
          if (!this.disable) {
            vueInstance.action = "8";
            vueInstance.$data.actionId = 8;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "PLANTING" || e === "Sadnja") {
          if (!this.disable) {
            vueInstance.action = "9";
            vueInstance.$data.actionId = 9;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "DESTROYING" || e === "Krčenje") {
          if (!this.disable) {
            vueInstance.action = "10";
            vueInstance.$data.actionId = 10;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "TRELLIS" || e === "Naslon") {
          if (!this.disable) {
            vueInstance.action = "11";
            vueInstance.$data.actionId = 11;

            if (isTankSelected === true) {
              modalOpen();
            } else {
              this.action = 0;
              alert("Niste izabrali vinograd");
            }
          } else
            alert(
              "Alert"
            );
        } else if (e === "SELLING" || e === "Prodaja grožđa" || e === "Prodaja ploda") {
          if (!this.disable) {
            vueInstance.action = "12";
            vueInstance.$data.actionId = 12;

            modalOpen();
          } else
            alert(
              "Alert"
            );
        }
      }

      return vinogradId;
    },
    customMounted() {
      

      if (this.action === "1") {
        serverBus.$emit(
          "vy_rezidba",
          this.id_vinograda,
          this.izabrani_red
        );

        serverBus.$off("vy_rezidba");
        }  else if (this.action === "2") {
        serverBus.$emit(
          "vy_djubrenje",
          this.id_vinograda,
          this.izabrani_red
        );

        serverBus.$off("vy_djubrenje");
        }  else if (this.action === "3") {

        serverBus.$emit(
          "vy_masinska_obrada",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_masinska_obrada");
      }  else if (this.action === "4") {
        serverBus.$emit(
          "vy_handing",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_handing");
      } else if (this.action === "5") {
        serverBus.$emit(
          "vy_spraying",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_spraying");
      } else if (this.action === "6") {
        serverBus.$emit(
          "vy_berba",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_berba");
      } else if (this.action === "7") {
        serverBus.$emit(
          "vy_condition",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_condition");
      } else if (this.action === "8") {
        serverBus.$emit(
          "vy_parameter",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_parameter");
      } else if (this.action === "9") {
        serverBus.$emit(
          "vy_sadnja",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_sadnja");
      }else if (this.action === "10") {
        serverBus.$emit(
          "vy_destroying",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_destroying");
      }else if (this.action === "11") {
        serverBus.$emit(
          "vy_trellising",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_trellising");
      }else if (this.action === "12") {
        serverBus.$emit(
          "vy_selling",
          this.id_vinograda,
          this.izabrani_red
        );
        
        serverBus.$off("vy_selling");
      }
    }
  },
  mounted() {
    serverBus.$on("open_modal", (akcija, e, item) => {
      this.izabrani_red = item;

      this.naziv_vinograda = item.name;

      this.actionId = akcija;

      this.actionsOnTank(e);

    })

    serverBus.$off("disable_action_vineyard");

    serverBus.$on("disable_action_vineyard", nizVred => {
      let i = 0;

      while (i < nizVred.length) {
        this.actions[i].disabled = nizVred[i];

        if (nizVred[i]) {
          this.actions[i].iconName =
            this.actions[i].iconName.replace("-grey", "") + "-grey";
          this.actions[i].color = "#c3c3c3";
        } else {
          this.actions[i].iconName = this.actions[i].iconName.replace(
            "-grey",
            ""
          );
          this.actions[i].color = "#018389";
        }

        i++;
      }
    });
  },
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if(this.vinarija)
      this.strProdajaGrozdja = "Prodaja grožđa";
    else
      this.strProdajaGrozdja = "Prodaja ploda";

    this.actions = [
        {
          actionId: 1,
          text: "Rezidba",
          iconName: "rezidba",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 2,
          text: "Đubrenje",
          iconName: "djubrenje",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 3,
          text: "Mašinska obrada",
          iconName: "masinska_obrada",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 4,
          text: "Ručna obrada",
          iconName: "rucna_obrada",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 5,
          text: "Zaštita",
          iconName: "zastita",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 6,
          text: "Berba",
          iconName: "berba",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 7,
          text: "Stanje",
          iconName: "stanje_u_vinogradu",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 8,
          text: "Parametri",
          iconName: "parametri",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 9,
          text: "Sadnja",
          iconName: "sadnja",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 10,
          text: "Krčenje",
          iconName: "krcenje",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 11,
          text: "Naslon",
          iconName: "naslon",
          disabled: false,
          color: "#018389"
        },
        {
          actionId: 12,
          text: this.strProdajaGrozdja,
          iconName: "prodaja",
          disabled: false,
          color: "#018389"
        }
      ]
  }
  //}
};
</script>
<style scoped lang='scss'>
@import "./../parts/../../assets/sass/parts/modalStyles_siri_modal";

.Actions__Nav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;
  left: $closedNavWidth;
  padding: 10px 130px 10px 60px;
  background-color: rgb(247, 247, 247);
  @media (max-width: 1200px) {
    height: 71px;
    padding-top: 10px;
    padding-right: 55px;
  }
  ul {
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    list-style-type: none;
    justify-content: space-between;
    padding-left: 0;
    @media (max-width: 1200px) {
      display: none;
    }
    button {
      // color: #018389;
      font-weight: 300;
      letter-spacing: 0;
      text-decoration: none;
      text-transform: uppercase;
      font-family: "NunitoSans", sans-serif;
      // &:focus {
      //   outline: 1px solid #018389;
      // }
      > * {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        pointer-events: none;
      }
      img {
        margin-right: 7px;
        width: 37px;
        height: 37px;
      }
    }
    
    button:hover{
  transform:scale(1.2);
  transition: all .4s ease-in-out;
}
  }
  &__Select {
    display: none;
    @media (max-width: 1200px) {
      display: block;
      width: 200px;
      float: right;
    }

    .v-input {
      margin-top: 8px !important;
    } 
  }
  
}
</style>